// extracted by mini-css-extract-plugin
export default {"default":"Callback_default__MY9Wy","description":"Callback_description__sKtbr"};